// extracted by mini-css-extract-plugin
export default {"rootPost":"NxBZ1a","root":"dbwLAy","header":"un5cvk","left":"RCXs8R","menuCategoriesDisplay":"wP0EBn"};